/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Arrayscape Gaming Dashboard API
 * Comprehensive REST API for event management, business operations, and analytics
 * OpenAPI spec version: 1.0.0
 */

export type GetReportsIncomeParamsDateField = typeof GetReportsIncomeParamsDateField[keyof typeof GetReportsIncomeParamsDateField];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetReportsIncomeParamsDateField = {
  GetReportsIncomeParamsDateFieldBookingDate: 'booking_date',
  GetReportsIncomeParamsDateFieldDueDate: 'due_date',
  GetReportsIncomeParamsDateFieldInvoiceDate: 'invoice_date',
  GetReportsIncomeParamsDateFieldProgramDate: 'program_date',
} as const;
